import type { ApolloError } from '@apollo/client';

import { AppError } from '../../utils/error.ts';

type AdBudgetErrorCode =
  | 'GET_PRODUCT_SET_ERROR'
  | 'NO_AD_BUDGET_VALUE_ERROR'
  | 'GET_CONTRACT_BALANCES_ERROR'
  | 'GET_AD_BUDGETS_ERROR'
  | 'RATE_LIMIT_ERROR';

const toError = (error: ApolloError) => {
  if (error?.graphQLErrors[0]?.extensions?.code === 'RATE_LIMIT_REACHED') {
    return new AppError('RATE_LIMIT_ERROR', 'Too many requests', error);
  }

  return new AppError('GET_AD_BUDGETS_ERROR', error.message, error);
};

export type { AdBudgetErrorCode };
export { toError };
